import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Link, Stack, Typography, useTheme } from '@mui/material';

type PropTypes = {
  close: () => void;
  open: boolean;
};

export const LeaguePlayerStatsExplainedDialog = ({
  close,
  open,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={close} maxWidth={'md'} fullWidth>
      <DialogTitle>Stats Explained</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            <strong>Gets:</strong> correct answers submitted for team
          </Typography>
          <Typography>
            <strong>Pens:</strong> penalty strokes
          </Typography>
          <Typography>
            <strong>Asts:</strong> (assists) instances where player directly
            helped teammate's Get
          </Typography>
          <Typography>
            <strong>Plyd:</strong> games played
          </Typography>
          <Typography>
            <strong>Score</strong>: sum of Gets that scored less than 0
          </Typography>
          <Typography>
            <strong>Saves</strong>: number of Gets that scored 0 or greater
          </Typography>
          <Typography>
            <strong>APS: </strong>(advantage play score) sum of differences when
            Gets scored better than opposing team
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
